import { Link } from "react-router-dom";
import { CATEGORY_LABEL } from "@/mocks/products";
import { useLocalized } from "@/lib/localize";
import { useBilingual } from "@/lib/bilingual";
import { asset } from "@/lib/asset";

const ProductRange = () => {
  const loc = useLocalized();
  const b = useBilingual();

  const categories = [
    { id: "Dining Tables", image: asset("/editorial/categories/dining-tables.jpg") },
    { id: "Coffee Tables", image: asset("/editorial/categories/coffee-tables.jpg") },
    { id: "Console Tables", image: asset("/editorial/categories/console-tables.jpg") },
    { id: "Chairs", image: asset("/editorial/categories/chairs.jpg") },
    { id: "Sofas", image: asset("/editorial/categories/sofa.jpg") },
    { id: "TV Cabinets", image: asset("/editorial/categories/tv-cabinets.jpg") },
  ];

  return (
    <section className="py-14 md:py-24 bg-stone-900">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-amber-500 text-xs font-semibold tracking-widest uppercase mb-3">
              {b("Product Range", "產品範圍")}
            </p>
            <h2
              className="text-3xl md:text-5xl font-bold text-white"
              style={{ fontFamily: "var(--font-display)" }}
            >
              {b("Six Product Lines,", "六大產品線，")}
              <br />
              {b("Endless Possibilities", "無限組合可能")}
            </h2>
          </div>
          <Link
            to="/products"
            className="inline-flex items-center gap-2 border border-amber-700/60 hover:border-amber-500 text-amber-400 hover:text-amber-300 text-sm font-semibold px-7 py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer self-start md:self-auto"
          >
            {b("View Full Catalog", "查看完整型錄")}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => {
            const label = CATEGORY_LABEL[cat.id] ? loc(CATEGORY_LABEL[cat.id]) : cat.id;
            const to = `/products?category=${encodeURIComponent(cat.id)}`;
            return (
              <Link
                key={cat.id}
                to={to}
                className="group relative overflow-hidden rounded-xl cursor-pointer bg-stone-800"
                style={{ minHeight: "220px" }}
              >
                <div className="w-full h-52 overflow-hidden bg-stone-900">
                  <img
                    src={cat.image}
                    alt={label}
                    loading="lazy"
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-white font-bold text-base leading-tight">{label}</p>
                </div>
                <div className="absolute inset-0 border-2 border-amber-600/0 group-hover:border-amber-600/60 rounded-xl transition-all duration-300" />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductRange;
